export default function LegalShell({ title, lastUpdated, children }) {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-20" data-testid="legal-page">
      <span className="eyebrow">Legal</span>
      <h1 className="font-display tracking-tighter text-4xl sm:text-5xl mt-4">{title}</h1>
      {lastUpdated && <p className="text-slate-500 text-xs mt-2">Last updated: {lastUpdated}</p>}

      <article className="mt-10 prose prose-invert max-w-none text-slate-300 [&_h2]:font-display [&_h2]:text-xl [&_h2]:mt-10 [&_h2]:mb-3 [&_h2]:text-white [&_p]:leading-relaxed [&_p]:text-sm [&_li]:text-sm [&_a]:text-brand [&_a]:underline [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-3 [&_strong]:text-white">
        {children}
      </article>
    </div>
  );
}
